import { APP_CONFIG } from 'services/app-config'

export const CONFIG = {
  api: {
    orderDiscounts: `${APP_CONFIG.care_cluster}/order-discounts`,
  },
}
